import axios from 'axios';
import { getToken } from './auth';

const API_URL = 'https://backend.chamafruits.com';
const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getProviders = async (params = {}) =>
  (await axios.get(`${API_URL}/providers`, { ...withAuth(), params })).data;

export const getProvider = async (id, params = {}) =>
  (await axios.get(`${API_URL}/providers/${id}`, { ...withAuth(), params })).data;

export const createProvider = async (data) =>
  (await axios.post(`${API_URL}/providers`, data, withAuth())).data;

export const updateProvider = async (id, data) =>
  (await axios.patch(`${API_URL}/providers/${id}`, data, withAuth())).data;

export const softDeleteProvider = async (id) =>
  (await axios.delete(`${API_URL}/providers/${id}`, withAuth())).data;

export const restoreProvider = async (id) =>
  (await axios.patch(`${API_URL}/providers/${id}/restore`, {}, withAuth())).data;

export const addProviderBankAccount = async (id, data) =>
  (await axios.post(`${API_URL}/providers/${id}/bank-accounts`, data, withAuth())).data;

export const updateProviderBankAccount = async (id, bankAccountId, data) =>
  (await axios.patch(`${API_URL}/providers/${id}/bank-accounts/${bankAccountId}`, data, withAuth())).data;

export const deleteProviderBankAccount = async (id, bankAccountId) =>
  (await axios.delete(`${API_URL}/providers/${id}/bank-accounts/${bankAccountId}`, withAuth())).data;

export const getProviderSummary = async (id) =>
  (await axios.get(`${API_URL}/providers/${id}/summary`, withAuth())).data;

export const getProviderOpenStocks = async (id, params = {}) =>
  (await axios.get(`${API_URL}/providers/${id}/open-stocks`, { ...withAuth(), params })).data;

export const getProviderPayments = async (id, params = {}) =>
  (await axios.get(`${API_URL}/providers/${id}/payments`, { ...withAuth(), params })).data;

export const createProviderPayment = async (id, data) =>
  (await axios.post(`${API_URL}/providers/${id}/payments`, data, withAuth())).data;

export const updateProviderPayment = async (id, paymentId, data) =>
  (await axios.patch(`${API_URL}/providers/${id}/payments/${paymentId}`, data, withAuth())).data;

export const deleteProviderPayment = async (id, paymentId) =>
  (await axios.delete(`${API_URL}/providers/${id}/payments/${paymentId}`, withAuth())).data;

export const uploadProviderPaymentVoucher = async (id, paymentId, data) =>
  (await axios.post(`${API_URL}/providers/${id}/payments/${paymentId}/voucher`, data, withAuth())).data;
